import ReactPlayer from "react-player";
import { useEffect } from "react";

/**
 * Resets player readiness and instance whenever the source `playerKey` changes
 * (new transcode URL or subtitle tracks), forcing a fresh `ReactPlayer` mount.
 */
export default function useResetPlayerOnSourceChange(
  playerKey: string,
  setPlayer: (player: ReactPlayer | undefined) => void,
  setCanPlay: (canPlay: boolean) => void,
) {
  useEffect(() => {
    setCanPlay(false);
    setPlayer(undefined);
  }, [playerKey]);
}
